import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import { useMobileMenu } from "../context/MobileMenuContext";
import {
  HomeOutlined,
  FolderOutlined,
  FlagOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  AppstoreOutlined,
  SettingOutlined,
  BarChartOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";
import { isSfLoginEnabled } from "../auth/azureConfig";
import { colors } from "../config/constants";

const NavBar = () => {
  const location = useLocation();
  const { toggle: toggleMobileMenu, isOpen } = useMobileMenu();

  // Collect all navigation keys for selection logic
  const allNavKeys = [
    "/",
    "/create",
    "/p",
    "/po",
    "/pqs",
    "/pp",
    "/ppc",
    "/performance",
    "/roster",
  ].sort((a, b) => b.localeCompare(a));

  const getNavItems = () => {
    const navItems = [];

    if (isSfLoginEnabled()) {
      navItems.push({
        key: "objects",
        label: "Objects",
        icon: <SettingOutlined />,
        children: [
          {
            key: "/p",
            label: <Link to="/p">Projects</Link>,
            icon: <FolderOutlined />,
          },
          {
            key: "/po",
            label: <Link to="/po">Project Objectives</Link>,
            icon: <FlagOutlined />,
          },
          {
            key: "/pqs",
            label: <Link to="/pqs">Qualification Steps</Link>,
            icon: <CheckCircleOutlined />,
          },
          {
            key: "/pp",
            label: <Link to="/pp">Project Pages</Link>,
            icon: <FileTextOutlined />,
          },
          {
            key: "/ppc",
            label: <Link to="/ppc">Page Components</Link>,
            icon: <AppstoreOutlined />,
          },
        ],
      });
    }
    return navItems;
  };

  // Define navigation items with collapsible sections
  const navItems = [
    {
      key: "/",
      label: <Link to="/">Home</Link>,
      icon: <HomeOutlined />,
    },
    // {
    //   type: "divider",
    // },
    ...getNavItems(),
    {
      key: "metrics",
      label: "Metrics",
      icon: <BarChartOutlined />,
      children: [
        // Add performance-related navigation items here as needed
        // Example:
        {
          key: "/performance",
          label: <Link to="/performance">Performance</Link>,
          icon: <DashboardOutlined />,
        },
        {
          key: "/roster",
          label: <Link to="/roster">Roster</Link>,
          icon: <BarChartOutlined />,
        },
      ],
    },
  ];

  // Determine selected key based on current path
  const getSelectedKey = () => {
    const path = location.pathname;

    // Exact matches first
    if (path === "/" || path === "/create") {
      return path;
    }

    // Check if path starts with any nav item key
    for (const key of allNavKeys) {
      if (key !== "/" && path.startsWith(key)) {
        return key;
      }
    }

    return null;
  };

  const selectedKey = getSelectedKey();
  const selectedKeys = selectedKey ? [selectedKey] : [];

  const [openKeys, setOpenKeys] = React.useState([]);

  // Update open keys when location changes
  React.useEffect(() => {
    if (isOpen) {
      const path = location.pathname;
      const newOpenKeys = [];

      // Check if path matches any item in Objects section
      if (
        ["/p", "/po", "/pqs", "/pp", "/ppc"].some(
          (key) => path.startsWith(key + "/") || path === key,
        )
      ) {
        newOpenKeys.push("objects");
      }

      // Check if path matches any item in Metrics section
      if (path.startsWith("/performance") || path.startsWith("/roster")) {
        newOpenKeys.push("metrics");
      }

      setOpenKeys(newOpenKeys);
    } else setOpenKeys([]);
  }, [location.pathname, isOpen]);

  return (
    <Sider collapsed={!isOpen} width={260}>
      <Menu
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        onClick={() => setOpenKeys([])}
        items={navItems}
        className="bg-white"
        style={{
          height: "100%",
          borderRight: `1px solid ${colors.grey}`,
        }}
      />
    </Sider>
  );
};

export default NavBar;
